import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBqL74yMxVrazLyGUwweyTIG3dfEKCCo84",
  authDomain: "surtte-4bf22.firebaseapp.com",
  projectId: "surtte-4bf22",
  storageBucket: "surtte-4bf22.firebasestorage.app",
  messagingSenderId: "876719111475",
  appId: "1:876719111475:web:88d894c9b5f905d9fb5246",
  measurementId: "G-6FD57M3Y7D"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const messaging = getMessaging(app);

// Evita errores en servidores (SSR o localhost)
let analytics;
isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

export { app, auth, googleProvider, messaging, analytics };